export default "https://cdn-static.gokick.com/assets/713f881f9452b025a6ed3fcaec249d98fea8bb41/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";